import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const AlertDialog = (props) => {
	const { alertOpen, alertSetOpen, handleAlertClose } = props

	return (
		<div>
			<Dialog
				open={alertOpen}
				onClose={handleAlertClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">Success!</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						Your information was successfully sent to us. Look out for a response!
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleAlertClose} color="primary" autoFocus>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default AlertDialog
